var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notification-container"},_vm._l((_vm.displaying),function(ref){
var duration = ref.duration;
var id = ref.id;
var message = ref.message;
var type = ref.type;
return _c('Notification',{key:id,attrs:{"animationDuration":_vm.animationDuration,"duration":duration,"message":message,"type":type},on:{"close":function($event){return _vm.close(id)},"dismiss":function($event){return _vm.dismiss(id)}}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }